<div class="skeleton-loader box" [style.width]="_width" [style.height]="_height"></div>
